// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cancelTaskButton[data-v-3be58e8f] {\n  font-size: 16px;\n}\n.bar-show[data-v-3be58e8f] {\n  display: flex;\n  flex-direction: row-reverse;\n}\n@media screen and (max-width: 1175px) {\n.scale[data-v-3be58e8f] {\n    font-size: 15px;\n}\n.bar-show[data-v-3be58e8f] {\n    display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
